module.exports = __webpack_public_path__ + "img/anuncio_disney.9ead3ef0.png";